import { render, staticRenderFns } from "./TarifOverviewFriends.vue?vue&type=template&id=1e1faef0"
import script from "./TarifOverviewFriends.vue?vue&type=script&lang=js"
export * from "./TarifOverviewFriends.vue?vue&type=script&lang=js"
import style0 from "./TarifOverviewFriends.vue?vue&type=style&index=0&id=1e1faef0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports